module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticStyle: {
      "padding-top": ".2rem"
    }
  }), _vm._v(" "), _vm._l((_vm.list), function(item, k) {
    return _c('div', {
      key: k
    }, [_c('van-divider', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.list.length) ? _c('div', _vm._l((item.list), function(row, i) {
      return _c('van-cell-group', {
        key: i
      }, [(item.name == '教练资质') ? _c('div', [_c('div', {
        staticClass: "cert-li"
      }, [_c('div', {
        staticStyle: {
          "text-align": "center",
          "padding-top": ".2rem"
        }
      }, [_vm._v(_vm._s(row.cert.filename))]), _vm._v(" "), (row.cert.img) ? _c('img', {
        attrs: {
          "src": row.cert.img,
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), (row.cert.img2) ? _c('img', {
        attrs: {
          "src": row.cert.img2,
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "cert-button"
      }, [(!_vm.isApp) ? _c('van-button', {
        staticStyle: {
          "margin": "10px auto",
          "text-align": "center"
        },
        attrs: {
          "type": "default",
          "round": ""
        },
        on: {
          "click": function($event) {
            return _vm.download(row.name + '-' + row.grade, row.cert.url)
          }
        }
      }, [_vm._v("请点击按钮下载\n                ")]) : _c('van-button', {
        staticStyle: {
          "margin": "10px auto",
          "text-align": "center"
        },
        attrs: {
          "type": "default",
          "round": ""
        },
        on: {
          "click": function($event) {
            return _vm.download(row.name + '-' + row.grade, row.cert.url)
          }
        }
      }, [_vm._v("点击下载\n                ")])], 1)])]) : (item.name == '证书记录') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "等级",
          "value": row.grade
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "证书编号",
          "value": row.code,
          "is-link": ""
        },
        on: {
          "click": function($event) {
            return _vm.downloadHistoryPic(row)
          }
        }
      })], 1) : (item.name == '参赛记录') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "赛区",
          "value": row.saiqu_name
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "队伍",
          "value": row.mingcheng
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "时间",
          "value": row.date
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "名次",
          "value": row.prize
        }
      })], 1) : (item.name == '培训记录') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "日期",
          "value": row.date
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "名称",
          "value": row.name
        }
      })], 1) : _vm._e()])
    }), 1) : _c('div', {
      staticStyle: {
        "text-align": "center",
        "padding": "0.2rem",
        "margin": "0 0.2rem",
        "background": "#fff",
        "border-radius": ".2rem"
      }
    }, [_vm._v("系统中暂无记录")])], 1)
  }), _vm._v(" "), (_vm.emptyShow) ? _c('div', {}, [_c('van-empty', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "description": "暂无结果"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertPersonPhoto'
      }),
      expression: "{name: 'CertPersonPhoto'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("上传证件照")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cfda09d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cha/UserSearchJiaolian.vue
// module id = 2358
// module chunks = 0